import React from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import { Triangle } from '@components/ui'

const SelectTextContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  border: 1px solid rgb(232, 232, 232);
  border-radius: 4px;
  padding: 3px;
  text-align: center;
  cursor: pointer;
  color: rgb(34, 34, 34);
  transition: 0.4s;
  user-select: none;

  .triangle {
    position: absolute;
    right: 5px;
    top: 9px;
    transform: rotate(0);
    border-top: 6px solid rgb(193, 193, 193);
  }

  &.open {
    border-color: ${p => p.theme.colors.main};
  }
`

const SelectText = styled.div`
  width: 160px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const SelectPanel = styled.div`
  position: relative;
  display: none;
  animation: 0.1s linear slide-in;

  @keyframes slide-in {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`

const SelectItem = styled.div`
  padding: 7px;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: ${p => p.theme.colors.primary};
    background-color: rgb(0, 0, 0, 0.02);
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`

const SelectTriangle = styled.div`
  position: absolute;
  top: 2px;
  left: 14%;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid rgba(0, 0, 0, 0.1);
`

const InnerSelectTriangle = styled.div`
  position: absolute;
  top: 3px;
  left: 14%;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid white;
`

const SelectTop = styled.div`
  position: relative;
  height: 10px;
  width: 100%;
  z-index: 100;
`

const SelectList = styled.div`
  position: absolute;
  width: 200px;
  top: 10px;
  right: 0;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 8px 0 #ddd;
  transition: 0.4s;
  background-color: white;
  color: rgb(34, 34, 34);
`

const SelectBox = styled.div`
  position: relative;
  margin-top: 10px;

  &.open {
    ${SelectPanel} {
      display: block;
    }

    .triangle {
      transform: rotate(180deg);
    }
  }
`

export const Select = ({ map, value, onSelect }: any) => {
  const [open, setOpen] = useState(false)
  return (
    <SelectBox
      className={open ? 'open' : ''}
      onMouseLeave={() => {
        setOpen(false)
      }}
    >
      <SelectTextContainer
        className={open ? 'open' : ''}
        onClick={() => {
          setOpen(!open)
        }}
      >
        <SelectText>{map[value]}</SelectText>
        <Triangle className="triangle" />
      </SelectTextContainer>

      <SelectPanel>
        <SelectTop>
          <SelectTriangle />
          <InnerSelectTriangle />
        </SelectTop>
        <SelectList>
          {Object.entries(map).map(([key, value]) => {
            return (
              <SelectItem
                key={key}
                onClick={() => {
                  if (onSelect) onSelect(key)
                }}
              >
                {value}
              </SelectItem>
            )
          })}
        </SelectList>
      </SelectPanel>
    </SelectBox>
  )
}
